/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import Vue from 'vue';
import cacheAxios from '../../util/cacheAxios';

const newsAxios = axios.create();
const cache = new Map();
cacheAxios(newsAxios, cache);
newsAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims#/disruptive';
      }, 500);
    }
  });

export default {
  state: {
    allNews: [],
    revMomen: [],
    costMomen: [],
  },
  mutations: {
    setAllNews(state, news) {
      state.allNews = news;
    },
    setRevMomen(state, value) {
      state.revMomen = value;
    },
    setCostMomen(state, value) {
      state.costMomen = value;
    },
  },
  actions: {
    initDisruptorsData({
      commit,
    }) {
      newsAxios.get('/aims/api/disruptive/all')
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              commit('setAllNews', res.data);
              const arr = res.data.filter(task => task.data_type === 'BIZ');
              let cos = '';
              for (let i = 0; i < arr.length; i += 1) {
                if (arr[i].company !== undefined) {
                  if (cos === '') {
                    cos = cos.concat(arr[i].company, ';', arr[i].country);
                  } else {
                    cos = cos.concat(',', arr[i].company, ';', arr[i].country);
                  }
                }
              }
              newsAxios.post('/aims/api/disruptive/revenue', { companies: cos })
              .then((resR) => {
                if (resR.data) {
                    commit('setRevMomen', resR.data);
                  } else {
                    commit('setRevMomen', []);
                  }
              });
              newsAxios.post('/aims/api/disruptive/cost', { companies: cos })
              .then((resC) => {
                if (resC.data) {
                    commit('setCostMomen', resC.data);
                  } else {
                    commit('setCostMomen', []);
                  }
              });
            }
          }
        });
    },
  },
  getters: {

  },
};



// WEBPACK FOOTER //
// ./src/store/modules/disruptorsModule.js